export default {
  path: '/security',
  component: () => import('./components/Layout.vue'),
  children: [
    {
      path: 'login',
      name: 'login',
      component: () => import('./pages/Login.vue')
    },
    {
      path: 'register',
      name: 'register',
      component: () => import('./pages/RegisterSelectType.vue')
    },
    {
      path: 'register/professional',
      name: 'registerProfessional',
      component: () => import('./pages/RegisterProfessional.vue')
    },
    {
      path: 'register/patient',
      name: 'registerPatient',
      component: () => import('./pages/RegisterPatient.vue')
    },
    {
      path: 'register/success',
      name: 'registerSuccess',
      component: () => import('./pages/RegisterSuccess.vue')
    },
    {
      path: 'password-renewal',
      name: 'password-renewal',
      component: () => import('./pages/PasswordRenewal.vue')
    },
    {
      path: 'password-renewal/success',
      name: 'password-renewal-success',
      component: () => import('./pages/PasswordRenewalSuccess.vue')
    },
    {
      path: 'verify-email',
      name: 'verify-email',
      component: () => import('./pages/VerifyEmail.vue'),
      props: route => {
        return {
          prefilledEmail: route.query.email,
          prefilledCode: route.query.code
        }
      }
    },
    {
      path: 'verify-mobile-phone',
      name: 'verify-mobile-phone',
      component: () => import('./pages/VerifyMobilePhone.vue')
    },
    {
      path: 'mfa',
      name: 'mfa',
      component: () => import('./pages/TwoFactorAuthentication.vue')
    },
    {
      path: 'forgot-password',
      name: 'forgotPassword',
      component: () => import('./pages/PasswordRecovery.vue')
    },
    {
      path: 'forgot-password/success',
      name: 'forgotPasswordSuccess',
      component: () => import('./pages/PasswordRecoverySuccess.vue')
    },
    {
      path: 'accept-cgu',
      name: 'acceptCgu',
      component: () => import('./pages/AcceptCgu.vue')
    },
    {
      path: 'first-login',
      name: 'firstLogin',
      component: () => import('./pages/FirstLogin.vue'),
      props: route => {
        return {
          personIdentifier: route.query.personIdentifier,
          prefilledEmail: route.query.email,
          prefilledCode: route.query.code
        }
      }
    },
    {
      path: 'biometrics',
      name: 'biometrics',
      component: () => import('./pages/Biometrics.vue')
    },
    {
      path: 'lock-account',
      name: 'lockAccount',
      component: () => import('./pages/LockAccount.vue'),
      props: route => ({
        email: route.query.email,
        code: route.query.code
      }),
      meta: {
        anonymous: true,
        anonymousOnly: false
      }
    },
    {
      path: 'account-locked',
      name: 'accountLocked',
      component: () => import('./pages/AccountLocked.vue'),
      props: route => ({ username: route.query.username }),
      meta: {
        anonymous: true,
        anonymousOnly: false
      }
    }
  ],
  meta: {
    anonymousOnly: true,
    supportsRedirect: true
  }
}
